var React = require('react');

function MinusCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.16659 10.8333V13.1666H17.8333V10.8333H6.16659ZM11.9999 0.333252C5.55992 0.333252 0.333252 5.55992 0.333252 11.9999C0.333252 18.4399 5.55992 23.6666 11.9999 23.6666C18.4399 23.6666 23.6666 18.4399 23.6666 11.9999C23.6666 5.55992 18.4399 0.333252 11.9999 0.333252ZM11.9999 21.3333C6.85492 21.3333 2.66659 17.1449 2.66659 11.9999C2.66659 6.85492 6.85492 2.66659 11.9999 2.66659C17.1449 2.66659 21.3333 6.85492 21.3333 11.9999C21.3333 17.1449 17.1449 21.3333 11.9999 21.3333Z"}));
}

MinusCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MinusCircle;

MinusCircle.default = MinusCircle;
